import { ApiService } from '@libs-uuif/shared/api-service';
/**
 * Configure and instantiate one ApiService so that we can have a customized
 * communication layer instance.
 */
// const apiService = new ApiService('https://10.202.8.58'); // FIXME: temp directly call api from my box
const apiService = new ApiService('https://msw-dev-onprem.eng.sonicwall.com'); // FIXME: temp directly call api from my box

export default apiService;
